import React from 'react';
import { Box, Typography } from '@mui/material';
import { makeStyles } from '@mui/styles';

import CameraPreview from './CameraPreview';
import useCaseMasterStore from './CaseMasterStore';
import { CasemasterAssessmentStates, InterviewerStates } from './constant';

const useStyles = makeStyles((theme) => ({
  root: {
    width: '100%',
    maxWidth: '302px',
    height: '100%',
    display: 'flex',
    flexDirection: 'column',
    padding: theme.spacing(6,0),
    gap: '24px', 
  },
  caseIntroduction: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(2),
  },
  caseDescription: {
    maxHeight : '150px',
    overflow : 'auto',
  },
  interviewerPreview: {
    width: '100%',
    height: '199px',
    overflow: 'hidden',
    border: '1px solid #E5E7EB',
    backgroundColor: '#F9FAFB',
  },
  intervieweePreview: {
    width: '100%',
    height: '199px',
    overflow: 'hidden',
    position: 'relative',
    border: '1px solid #E5E7EB',
    backgroundColor: '#F9FAFB',
  },
  interviewerContainer: {
    position: 'relative',
    width: '100%', 
    height: '100%'
  }
}));

const videoSX = {
  objectFit: 'cover',
  position: 'absolute',
  top: 0,
  left: 0,
  width: '100%',
  height: '100%',
  transition: 'opacity 0.8s ease-in-out',
}

const VideoPreview = ({ play = false }) => {
  const classes = useStyles();
  const waitingRef = React.useRef(null);

  const assessmentState = useCaseMasterStore(state => state.assessmentState);

  React.useEffect(() => {
    if (waitingRef.current) {
      if (assessmentState === CasemasterAssessmentStates.RUNNING) {
        const timeoutId = setTimeout(() => {
          waitingRef.current.play().catch(err => console.error('Play error:', err));
        }, 1500);
        return () => clearTimeout(timeoutId);
      } else {
        waitingRef.current.pause();
      }
    }
  }, [assessmentState]);

  return (
    <Box id="interviewer-container" className={classes.interviewerContainer}>
      <video
        ref={waitingRef}
        src="https://assets.languify.in/video/interviewer_waiting.mp4"
        muted
        loop
        playsInline
        style={{
          ...videoSX,
          opacity: play ? 0 : 1,
          zIndex: play ? 1 : 2,
        }}
      />
      
      <video
        src="https://assets.languify.in/video/interviewer_speaking.mp4"
        muted
        autoPlay
        loop
        playsInline
        style={{
          ...videoSX,
          opacity: play ? 1 : 0,
          zIndex: play ? 2 : 1,
        }}
      />
    </Box>
  );
};

const InterviewerSection = () => {
  const classes = useStyles();
  
  const interviewerState = useCaseMasterStore(state => state.interviewerState);
  const casemasterProblem = useCaseMasterStore(state => state.casemasterProblem);
  return (
    <Box className={classes.root}>
      <Box className={classes.caseIntroduction}>
        <Typography variant='h6-semiBold' color='primary.dark'>
          Case Introduction
        </Typography>
        <Typography className={classes.caseDescription} variant='body01-medium' color='neutral.clr-700'>
          {casemasterProblem?.problem}
        </Typography>
      </Box>

      {/* Interviewer Video */}
      <Box id='interviewer' className={classes.interviewerPreview}>
        <VideoPreview play={interviewerState === InterviewerStates.SPEAKING} />
      </Box>

      {/* Your Video */}
      <Box id="interviewee-container" className={classes.intervieweePreview}>
        <Box id="interviewee" style={{ width: '100%', height: '100%' }}>
          <CameraPreview />
        </Box>
      </Box>
    </Box>
  );
}

export default InterviewerSection;
